interface SectionProps {
  children: React.ReactNode;
  sectionTitle: string;
}

const Section = ({ children, sectionTitle }: SectionProps) => {
  return (
    <div className="rounded-md shadow-md p-4 my-3 flex flex-col gap-3">
      <h1 className="text-lg font-semibold text-gray-800">{sectionTitle}</h1>
      <div className="flex-1">{children}</div>
    </div>
  );
};

export default Section;
